module.exports = __webpack_public_path__ + "img/Norris-Hall-Fall-2014-CC_07_SN.01a61a99.webp";